import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ImportJobDetails } from '../../../models/import';

@Component({
  selector: 'cube-import-completed-dialog',
  templateUrl: './import-completed-dialog.component.html',
  styleUrls: ['./import-completed-dialog.component.scss'],
  standalone: false,
})
export class ImportCompletedDialogComponent {
  jobDetails: ImportJobDetails;

  constructor(@Inject(MAT_DIALOG_DATA) private matDialogData: any) {
    this.jobDetails = this.matDialogData.jobDetails;
  }
}
